import React from "react"

import { CounsellorHelp } from "@components/charts"
import { Small } from "@components/type"

const Side = () => (
  <>
    <h3>The Counsellor Helped Me To:</h3>
    <Small>Tap/hover to view data</Small>
    <CounsellorHelp />
  </>
)

export default Side
